import { reduxForm, formValueSelector, change, reset } from 'redux-form'
import { connect } from 'react-redux'
import flowRight from 'lodash/flowRight'
import { translate } from 'loankeeper-common/helpers'

import { PASSWORD_RESET_FORM } from '../constants'

export const translateMain = (key: string): string => translate(`frm_password_recovery-${key}`)
export const translateWeb = (key: string): string => translate(`frm_web_messages-${key}`)
export const translateLogin = (key: string): string => translate(`frm_login-${key}`)

const selector = formValueSelector(PASSWORD_RESET_FORM)

type FormValues = {
  username: string
  mobile: string
  otpCode: string
  password: string
  repeatPassword: string
}

type PersonKeys = keyof FormValues

export const usernamePattern = /^[0-9a-zA-Z]*$/
const mobileNumberPattern = /^[0-9]*$/
const otpCodePattern = /\d{3}\s\d{3}/
export const passwordPattern = /^[A-Za-z0-9_@./#&+-<>?=()*^%$!`~|/[\]\\{},.;:'"]*$/

const validate = (values: FormValues) => {
  const errors: Partial<FormValues> = {}
  if (values.username) {
    if (!usernamePattern.test(values.username)) {
      errors.username = 'Only latin symbols and numbers are allowed'
    }
    if (!mobileNumberPattern.test(values.mobile)) {
      errors.mobile = 'Only numbers are allowed'
    }
    if (!otpCodePattern.test(values.otpCode)) {
      errors.otpCode = 'only numbers are allowed'
    }
  }
  console.log(errors)
  return errors
}

export default flowRight(
  reduxForm({
    form: PASSWORD_RESET_FORM,
    initialValues: {
      username: '',
      mobile: '',
      otpCode: '',
      password: '',
      repeatPassword: '',
    },
    validate,
  }),
  connect(
    (state) => {
      const { username, mobile, otpCode, password, repeatPassword } = selector(
        state,
        'username',
        'mobile',
        'otpCode',
        'password',
        'repeatPassword',
      )
      return {
        username,
        mobile,
        otpCode,
        password,
        repeatPassword,
      }
    },
    (dispatch) => ({
      resetinput: (inputName: string) => dispatch(change(PASSWORD_RESET_FORM, inputName, '')),
      resetFormValues: () => dispatch(reset(PASSWORD_RESET_FORM)),
    }),
  ),
)

export const normalizeOTP = (value: string, previousValue: string) => {
  if (!value) {
    return value
  }
  const onlyNums = value.replace(/[^\d]/g, '')
  if (!previousValue || value.length > previousValue.length) {
    // typing forward
    if (onlyNums.length === 3) {
      return onlyNums + ' '
    }
    if (onlyNums.length === 6) {
      return onlyNums.slice(0, 3) + ' ' + onlyNums.slice(3)
    }
  }
  if (onlyNums.length <= 3) {
    return onlyNums
  }
  if (onlyNums.length <= 6) {
    return onlyNums.slice(0, 3) + ' ' + onlyNums.slice(3)
  }
  return onlyNums.slice(0, 3) + ' ' + onlyNums.slice(3, 6)
}

export const normalizeUsername = (value: string, previousValue: string) => {
  if (usernamePattern.test(value)) {
    return value
  }
  return previousValue
}

export const normalizeMobileNumber = (value: string, previousValue: string) => {
  if (mobileNumberPattern.test(value)) {
    return value
  }
  return previousValue
}

export const normalizePassword = (value: string, previousValue: string) => {
  if (passwordPattern.test(value)) {
    return value
  }
  return previousValue
}
